export default __webpack_public_path__ + "static/test_1_4_ru-2c82b063ac046098e6e42042d1ddac6d.png";